import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { SubmissionTimeline as SubmissionTimelineData } from '@/types';
import { SubmissionTimelineChart } from './SubmissionTimelineChart';

export function SubmissionTimeline({ data }: { data: SubmissionTimelineData }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Submission Timeline</CardTitle>
        <CardDescription>
          Cumulative submissions breakdown by participant type (solo, looking
          for team, with team)
        </CardDescription>
      </CardHeader>
      <CardContent>
        <SubmissionTimelineChart data={data} />
      </CardContent>
    </Card>
  );
}
